import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  confirmParticipateFailed,
  confirmParticipateSuccess,
  confirmParticipateStart,
} from "../redux/confirmParticipate";

import { toast } from "react-toastify";
import { updateStatusParticipateApi } from "core/http/service/interviewSchedule";
import { getDetailInterviewStart } from "../redux/getDetailInterview";
import { SCREEN } from "helper/roleChecker/Screens";
import { getEventsStart } from "../redux/filterEvent";

function* confirmParticipateWork(
  action: ReturnType<typeof confirmParticipateStart>
) {
  try {
    const { callback, ...rest } = action.payload;

    const res = yield call(updateStatusParticipateApi, rest);
    if (!res) return;
    yield put({
      type: confirmParticipateSuccess.type,
    });

    yield put({
      type: getDetailInterviewStart.type,
      payload: {
        screenCode: SCREEN.IP_025,
        scheduleId: rest?.scheduleId,
      },
    });

    toast.success("Xác nhận thành công!");

    yield put({
      type: getEventsStart.type,
      payload: SCREEN.IP_026,
    });

    if (callback) {
      callback();
    }
  } catch (error: any) {
    yield put({
      type: confirmParticipateFailed.type,
    });

    toast.error(error?.response?.data?.message || "Xác nhận thất bại!");
  }
}

function* watchConfirmParticipate() {
  yield takeLatest(confirmParticipateStart.type, confirmParticipateWork);
}

export default function* confirmParticipateSaga() {
  yield all([watchConfirmParticipate()]);
}
